import { RouteConfig } from 'vue-router'

const Home = () => import('../views/Home.vue')

export const homeRoute: RouteConfig = {
  path: 'home',
  name: 'tus_home',
  component: Home,
  meta: {
    title: '体智云®️大学体育',
  },
}

export default [homeRoute]
